import React, { useEffect, useState } from "react";

import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";

import { getSolutionContactDetailsByTag } from "../../utils/data/getContactDetails";
import styles from "./index.module.scss";
import SlideIn from "../../components/slide-in/SlideIn";
import ContactPhone from "../../components/contact-details-box/contact-methods/contact-phone/ContactPhone";
import ContactChat from "../../components/contact-details-box/contact-methods/contact-chat/ContactChat";
import getCallStatusConfig from "./call-status-config";

function ViewContactDetail({ callStatus }) {
  const callStatusConfig = getCallStatusConfig(callStatus?.toLowerCase());
  const [showContactDetails, setShowContactDetails] = useState(false);
  const [supplierContactConfig, setSupplierContactConfig] = useState(null);
  useEffect(() => {
    getSolutionContactDetailsByTag(`repairUpdateElectricalItem`).then(config => setSupplierContactConfig(config));
  }, []);

  return (
    <div className={styles.contactUsContainer}>
      <h3>Need Help?</h3>
      {!showContactDetails && (
        <SecondaryButton className={styles.button} onClick={() => setShowContactDetails(true)}>
          Contact us
        </SecondaryButton>
      )}
      {showContactDetails && !supplierContactConfig && <LoadingSpinner />}
      {showContactDetails && supplierContactConfig && (
        <div className={styles["contact-options"]}>
          <div className={styles.box}>
            <SlideIn>
              <ContactPhone
                className={styles.button}
                title="Speak to one of our Partners. Have your repair reference ready, if you have one."
                config={supplierContactConfig.phone}
                solutionId="Repairs | Tracking"
              />
            </SlideIn>
          </div>
          <div className={styles.box}>
            <SlideIn>
              <ContactChat
                className={styles.button}
                config={supplierContactConfig.chat}
                location={callStatusConfig?.liveChatLocation || "repairs-electrical | repair | unknown"}
              />
            </SlideIn>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewContactDetail;
